<template>
  <div class="business">
    <menuBox :step="2"></menuBox>
    <div class="about-title">
      <img class="left" src="../assets/left.png" alt="" />
      <div class="title">
        关于我们
      </div>
      <img class="right" src="../assets/right.png" alt="" />
      <!-- <p>
        In today's increasingly globalized economy, every enterprise on Earth is not an isolated entity; they are all global corporate citizens.
      </p> -->
    </div>
    <div class="business-box">
      <div class="b-title">关于我们</div>
      <div class="b-subtitle">
        脚踏实地，奔向未来
      </div>
      <div class="business-img-text">
        <img src="../assets/mission-2.png" />
        <div class="text text-l">
          <p>
            <img src="../assets/mission-3.png" alt="" />
            在软件开发领域，SAMORE HK LIMITED积极追求创新，致力于开发高效、智能的解决方案，成功推出多个应用于不同行业的软件产品，为客户提供了卓越的技术支持
          </p>
          <p>
            <img src="../assets/mission-3.png" alt="" />
            在全球投资方面，公司在跨国投资和资本市场运作中表现卓越，成功参与多个战略性投资项目，取得了显著的财务回报，树立了在投资领域的良好声誉
          </p>
        </div>
      </div>
    </div>
    <div class="business-partner">
      <div class="b-title">團隊介紹</div>
      <div class="b-subtitle">
        加入我們，創造更多的可能
      </div>
      <div class="partner-list">
        <div class="item">
          <img src="../assets/icon-1.png" alt="" />
          <div class="msg">
            設計部：畢業於設計名校，經驗豐富，打造人性化系統產品，提供卓越使用者體驗
          </div>
        </div>
        <div class="item">
          <img src="../assets/icon-2.png" alt="" />
          <div class="msg">
            軟體開發部：電腦專業畢業，技術經驗豐富，持續解決客戶需求，創造高品質系統體驗。
          </div>
        </div>
        <div class="item">
          <img src="../assets/icon-3.png" alt="" />
          <div class="msg">
            投資部：金融專業畢業，致力於評估上市項目，為客戶提供優質投資建議。
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    aboutUs() {
      this.$router.push({ path: "aboutUs" });
    },
  },
};
</script>
<style lang="less" scoped>
.about-title {
  background-image: url(../assets/about-1.png);
  width: 100%;
  height: 400px;
  background-size: 100% 100%;
  text-align: center;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  .title {
    font-size: 64px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  img {
    width: 40px;
    height: 40px;
  }
  .left {
    margin-bottom: 50px;
    margin-right: 20px;
  }
  .right {
    margin-top: 50px;
    margin-left: 20px;
  }
  p {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
}

.business-text {
  padding: 80px 360px 120px 360px;
  font-size: 28px;
  font-weight: 400;
  color: #999999;

  p {
    text-indent: 2em;
    margin-top: 28px;
  }
}

.business-box {
  padding: 0px 360px;
  .b-title {
    margin-top: 120px;
    font-size: 58px;
    font-family: Roboto, Roboto;
    font-weight: bold;
    text-align: center;
    color: #45289f;
  }
  .b-subtitle {
    font-size: 22px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    color: rgba(51, 51, 51, 0.6);
    margin-bottom: 90px;
    text-align: center;
  }
  .business-img-text {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 120px;

    img {
      width: 560px;
    }

    .text {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-left: 50px;
      p:first-child {
        margin-bottom: 60px;
      }
      p {
        width: 474px;
        padding: 30px 50px;
        padding-top: 60px;
        height: 130px;
        box-shadow: 2px 2px 20px 5px rgba(209, 209, 234, 0.3);
        border-radius: 8px 8px 8px 8px;
        text-align: center;
        position: relative;
        img {
          width: 88px;
          height: 88px;
          position: absolute;
          top: -38px;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }
  }
}
.business-partner {
  padding: 0px 360px;
  padding-bottom: 100px;
  .b-title {
    margin-top: 120px;
    font-size: 58px;
    font-family: Roboto, Roboto;
    font-weight: bold;
    text-align: center;
    color: #45289f;
  }
  .b-subtitle {
    font-size: 22px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    color: rgba(51, 51, 51, 0.6);
    margin-bottom: 90px;
    text-align: center;
  }
  .partner-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 120px;
    .item {
      position: relative;
      img {
        width: 368px;
        height: 286px;
        margin-bottom: 20px;
      }
      .msg {
        width: 285px;
        padding: 16px;
        height: 100px;
        background-color: #ffffff;
        box-shadow: 0px 8px 16px 0px rgba(171, 190, 209, 0.4);
        border-radius: 8px;
        margin: auto;
        margin-top: -80px;
        font-size: 20px;
        font-family: Inter, Inter;
        font-weight: normal;
        color: #717171;
        line-height: 28px;
        text-align: center;
        position: absolute;
        left: 0;
        right: 0;
      }
    }
  }
}
.statr-box {
  background: #b043fc;
  padding: 42px 360px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .s-text {
    color: #fff;

    .text-1 {
      font-size: 40px;
      font-weight: 400;
      color: #ffffff;
    }

    .text-2 {
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .btn {
    cursor: pointer;
    width: 160px;
    height: 64px;
    background: #ffffff;
    border-radius: 8px;
    line-height: 64px;
    font-size: 24px;
    text-align: center;
    font-weight: 400;
    color: #b043fc;
  }
}
</style>
